// extracted by mini-css-extract-plugin
export default {"price_order":"main_price_order__KGHd7","price_add_to_wallet":"main_price_add_to_wallet__K5VOe","span_points":"main_span_points__HIs44","greenActive":"main_greenActive__Ihddf"};